import { render, staticRenderFns } from "./VideoClipPreview.vue?vue&type=template&id=0b12aaaa&scoped=true&"
import script from "./VideoClipPreview.vue?vue&type=script&lang=ts&"
export * from "./VideoClipPreview.vue?vue&type=script&lang=ts&"
import style0 from "./VideoClipPreview.vue?vue&type=style&index=0&id=0b12aaaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b12aaaa",
  null
  
)

export default component.exports